<mat-card appearance="outlined" class="rightmost textalign-left full-height-card">
  <mat-card-header>
    <mat-card-title>{{ 'PAGES.STAGING.CREATE_STAGING_MODAL.TITLE' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <span>
      {{ 'PAGES.STAGING.CREATE_STAGING_MODAL.DESCRIPTION' | translate }}
    </span>
  </mat-card-content>
  <mat-card-actions align="end">
    <button
      (click)="createStagingFromBackup()"
      [disabled]="disableButton"
      class="action-button"
      color="accent"
      mat-button
      type="button"
    >
      {{ 'PAGES.STAGING.CREATE_STAGING_MODAL.BUTTONS.CREATE_STAGING_FROM_BACKUP' | translate }}
    </button>
    <button
      (click)="createStaging()"
      [disabled]="disableButton"
      class="action-button"
      color="accent"
      mat-raised-button
      type="button"
    >
      {{ 'PAGES.STAGING.CREATE_STAGING_MODAL.BUTTONS.CREATE_STAGING' | translate }}
    </button>
  </mat-card-actions>
</mat-card>
